import React from 'react';
import './Label-input.css';
import Badge from '../Badge/Badge';

interface LabelInputProps {
    labelTitle: any;
    labelContent: any;
    badge?: boolean;

}

const LabelInput: React.FC<LabelInputProps> = ({ labelTitle, labelContent, badge }) => {
    return (
        <div className="label-form-input">
            <span className="label-title" slot="label">
                {labelTitle}
                <div className="label-badge-container">
                    <span className="label-content">
                        {labelContent}
                        </span>
                        {/* {badge ? (<span className="badge-data create">
                            <Badge data="E"/>
                        </span>

                        ) : (
                            ""
                        )} */}
                    
                </div>
            </span>
        </div>
    )
}

export default LabelInput;